import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { IThreat } from '../../../../shared/models/threat';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { ThreatService } from '../../../../shared/services/threat.service';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'threat-edit',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule,
    SpinnerComponent,
    NoEmojiDirective
  ],
  templateUrl: './threat-edit.component.html',
  styleUrl: './threat-edit.component.css'
})
export class ThreatEditComponent implements OnInit {
  icons = Icons;
  threatForm: FormGroup = new FormGroup({});

  loading: boolean = false;

  @Input() threatToEdit: IThreat | null = null;

  @Output() onClose = new EventEmitter<void>;
  @Output() onSave = new EventEmitter<any>;

  constructor(
    private threatService: ThreatService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['threatToEdit'] && this.threatToEdit) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.threatForm = new FormGroup({
      threat: new FormControl(this.threatToEdit?.threat, Validators.required),
      probability: new FormControl(this.threatToEdit?.probability || 'Highly likely'),  
      magnitude: new FormControl(this.threatToEdit?.magnitude || 'Catastrophic'),
      warning: new FormControl(this.threatToEdit?.warning || 'Minimal'),
      duration: new FormControl(this.threatToEdit?.duration || '12+ hrs'),
      risk_priority: new FormControl(this.threatToEdit?.risk_priority || 'High')
    })
  }

  closeModal(): void {
    this.onClose.emit();
  }

  saveEdit(): void {
    if (this.threatToEdit && this.threatForm.valid) {
      this.loading = true;
      const threatPayload = this.threatForm.value;
      this.threatService.editThreat(threatPayload, this.threatToEdit.id).subscribe({
        next: (response) => {
          this.loading = false;
          if (response.has_error) {
            this.loading = false;
            this.onSave.emit({ type: 'unsuccess', message: response.message });
          } else {
            this.onSave.emit({ type: 'success', message: 'This occurred after updating a threat.' });
          }
        },
        error: (error) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: error.message });
        }
      })
    }
  }
}
